var React = require('react');

function UserInline (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t\t.st0 {\n\t\t\tfill: currentColor;\n\t\t}\n\t"),React.createElement("path",{"className":"st0","d":"M34.3,27.2c-1.1-2.2-4.8-3.6-10-5.5c-1-0.4-1.6-0.5-1.9-1.3c-0.3-0.8-0.2-1.7,0.2-2.4c2.1-2.2,3.1-5.6,3.1-9.8\n\tc0-5.7-3.9-8.2-7.7-8.2s-7.7,2.5-7.7,8.2c0,4.3,1,7.6,3.1,9.8c0.5,0.7,0.6,1.6,0.2,2.4c-0.3,0.8-0.9,1-1.9,1.3\n\tc-5.2,1.9-8.9,3.3-10,5.5c-1,2-1.5,4.2-1.6,6.4c0,0.4,0.3,0.7,0.7,0.7h34.4c0.4,0,0.7-0.3,0.7-0.7C35.8,31.4,35.3,29.2,34.3,27.2z","key":1})]);
}

UserInline.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 35.9 34.4","style":{"enableBackground":"new 0 0 35.9 34.4"},"xmlSpace":"preserve"};

module.exports = UserInline;

UserInline.default = UserInline;
